
const API_BASE  = "https://srinivasafleet.com/api";


function getAuthToken() {
  return (
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    null
  );
}

function buildHeaders(hasBody) {
  const headers = {};
  if (hasBody) headers["Content-Type"] = "application/json";

  const token = getAuthToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  return headers;
}

async function parseErrorDetail(res) {
  try {
    const body = await res.json();
    if (Array.isArray(body?.detail)) {
      return body.detail
        .map((d) => d?.msg || JSON.stringify(d))
        .join("; ");
    }
    return body?.detail || res.statusText || `Request failed (${res.status})`;
  } catch {
    return res.statusText || `Request failed (${res.status})`;
  }
}

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, options);

  if (!res.ok) {
    const detail = await parseErrorDetail(res);
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }

  if (res.status === 204) return null;

  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

export function listMasterRecords(tablePath, includeInactive = false) {
  const qs = includeInactive ? "?include_inactive=true" : "";
  return request(`/master/${tablePath}${qs}`, {
    method: "GET",
    headers: buildHeaders(false),
  });
}

export function createMasterRecord(tablePath, payload) {
  return request(`/master/${tablePath}`, {
    method: "POST",
    headers: buildHeaders(true),
    body: JSON.stringify(payload),
  });
}

export function updateMasterRecord(tablePath, id, payload) {
  return request(`/master/${tablePath}/${id}`, {
    method: "PUT",
    headers: buildHeaders(true),
    body: JSON.stringify(payload),
  });
}

export function deleteMasterRecord(tablePath, id) {
  return request(`/master/${tablePath}/${id}`, {
    method: "DELETE",
    headers: buildHeaders(false),
  });
}